const o = (r) => Array.isArray(r) ? r.map(({ field: t, order: e }) => `orderby[${t}]=${e}`).join("&") : "";
export {
  o as generateSort
};
